import { render } from "./MmiDraftPreview.vue?vue&type=template&id=8409b560&scoped=true&ts=true"
import script from "./MmiDraftPreview.vue?vue&type=script&lang=ts"
export * from "./MmiDraftPreview.vue?vue&type=script&lang=ts"

import "./MmiDraftPreview.vue?vue&type=style&index=0&id=8409b560&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8409b560"]])

export default __exports__